declare namespace $ {

	type $mol_image__uri_shm_hitalama_map_widget_float_image_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_download__title_shm_hitalama_map_widget_float_image_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_hitalama_map_widget_float_image_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['image_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_image_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['image_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_image_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['image_copy'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_image_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_map_widget_tools__widget_shm_hitalama_map_widget_float_image_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['widget'] >
	>
	type $shm_hitalama_map_widget_tools__Map_page_shm_hitalama_map_widget_float_image_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_image['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['Map_page'] >
	>
	type $shm_hitalama_map_widget_tools__sub_shm_hitalama_map_widget_float_image_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_tools['sub'] >
	>
	export class $shm_hitalama_map_widget_float_image extends $shm_hitalama_map_widget_float {
		image_uri( ): string
		Image( ): $mol_image
		image_blob( ): any
		image_file_name( ): string
		Download( ): $mol_button_download
		image_copy( next?: any ): any
		Copy_image_icon( ): $mol_icon_content_copy
		Copy_image( ): $mol_button_minor
		Up( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Up'] >
		Down( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Down'] >
		Copy_code( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Copy_code'] >
		Lock( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Lock'] >
		Fullscreen( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Fullscreen'] >
		Link_pick( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Link_pick'] >
		Delete( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_image['Tools'] >['Delete'] >
		controls( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
		Tools( ): $shm_hitalama_map_widget_tools
	}
	
}

//# sourceMappingURL=image.view.tree.d.ts.map